import React from 'react';
import { alpha } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { UserEntity } from 'ha/types/UserEntity';
import { UserAvatar } from 'ha/components/UserAvatar';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { Link } from 'ha/ui.legacy/Link';
import { SvgIcon } from 'ha/components.legacy/SvgIcon';
import { units } from '@hbf/dsl';

interface Props {
  user: UserEntity;
  linkToProfile?: boolean;
  newAdvertiserDesign?: boolean;
}

const useStyles = makeStyles()(theme => ({
  iconWrapper: {
    backgroundColor: alpha(theme.palette.common.white, 0.3),
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    transition: 'all 100ms ease-in',
    zIndex: 2,

    '&:hover': {
      opacity: 1,
      cursor: 'pointer',
    },
    '& svg': {
      position: 'absolute',
      fill: theme.palette.white.main,
      height: units.rem(3.5),
      width: units.rem(3.5),
      top: `calc(50% - 3.5rem / 2 - 0.2rem)`,
      left: `calc(50% - 3.5rem / 2)`,
    },
  },
}));

const UserCardProfileAvatar: React.FC<Props> = ({
  user,
  linkToProfile,
  newAdvertiserDesign,
  ...rest
}) => {
  const { classes } = useStyles();
  const { urlResolver } = useIntl();

  const userAvatar = (
    <UserAvatar
      avatarURL={user.avatarURL}
      size={newAdvertiserDesign ? 'sm' : undefined}
    />
  );

  if (!linkToProfile) {
    return userAvatar;
  }

  return (
    <Track name="Clicked Advertiser name" type="link">
      <Link
        to={urlResolver.getLinkToUserPage(user.entityId)}
        target="_blank"
        title="Profile preview"
        skipLangFormat
        noFollow
        data-test-locator="User card profile avatar"
      >
        <div className={classes.iconWrapper} {...rest}>
          <SvgIcon name="id-card" />
        </div>
        {userAvatar}
      </Link>
    </Track>
  );
};

export { UserCardProfileAvatar };
